import type { MutableRefObject } from 'react';
import { JSX } from '@caspio/components';
export interface GridColumnOption extends JSX.CasGridColumn {
	class?: string;
	cellRenderer?: any;
}

export interface GridColumnConfig {
	ref?: MutableRefObject<HTMLCasGridColumnElement | null>;
	actions?: any;
	identifier: ColumnIdentifier;
	options: GridColumnOption;
}

export interface GridConfig extends JSX.CasGrid {
	class?: string;
}

// TODO add commented fields as soon as back end is ready
export enum ColumnIdentifier {
	// CASPIO_URL = "Caspio URL",
	// COMPANY = "Company",
	ACCOUNT_ID = 'Account ID',
	CREATED = 'Created',
	SITE = 'Site',
	MARKET = 'Market',
	PLAN = 'Plan',
	OWNER = 'Owner',
	COUNTRY = 'Country',
	SALES_REP = 'Sales Rep',
	ACCT_MGMT_REP = 'CSM Rep',
	PROVIDER = 'Provider',
	PROMOTER = 'Promoter',
	STATUS = 'Status',
}

export interface FilterResponseValues {
	Status: string;
	DisplayName: string;
	Department: string;
	Office: string;
	UserAvatarUrl: string;
}

export interface ResponseData {
	AccountId: string;
	AccountName: string;
	CaspioUrl: string;
	Created: string;
	Site: string;
	Market: string;
	Plan: string;
	Owner: string;
	Company: string;
	Country: string;
	SalesRep: string;
	AcctMgmtRep: string;
	Provider: string;
	Promoter: string;
	Status: string;
}
